// import {
//   Facebook,
//   Twitter,
//   Instagram,
//   Linkedin,
//   Mail,
//   Phone,
//   MapPin,
// } from 'lucide-react';
// import { Link } from 'react-router';
// import logo from '../../imports/logo-MORROCARS.png';

// export function Footer() {
//   return (
//     <footer className="w-full overflow-hidden bg-gradient-to-br from-[#2D323A] via-[#1E1E26] to-[#121212] text-white">

//       {/* Newsletter Section */}
//       <div className="border-b border-white/10">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 lg:py-12">

//           <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 md:gap-8">

//             {/* Newsletter Text */}
//             <div className="w-full md:flex-1">
//               <h3 className="text-xl sm:text-2xl mb-2 font-semibold">
//                 Stay Updated
//               </h3>

//               <p className="text-[#BFC2C7] text-sm sm:text-base leading-relaxed">
//                 Subscribe to get the latest listings and automotive news
//               </p>
//             </div>

//             {/* Newsletter Form */}
//             <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto md:min-w-[420px]">

//               <input
//                 type="email"
//                 placeholder="Enter your email"
//                 className="
//                   w-full
//                   sm:flex-1
//                   sm:min-w-0
//                   px-4
//                   py-3
//                   rounded-xl
//                   bg-white/10
//                   border border-white/20
//                   focus:outline-none
//                   focus:ring-2
//                   focus:ring-[#1E6DFF]
//                   focus:border-transparent
//                   placeholder-[#BFC2C7]
//                   text-white
//                 "
//               />

//               <button
//                 type="button"
//                 className="
//                   w-full
//                   sm:w-auto
//                   px-6
//                   py-3
//                   bg-[#1E6DFF]
//                   text-white
//                   rounded-xl
//                   hover:bg-[#1557d9]
//                   transition-colors
//                   whitespace-nowrap
//                 "
//               >
//                 Subscribe
//               </button>

//             </div>

//           </div>
//         </div>
//       </div>

//       {/* Main Footer Content */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 lg:py-12">

//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 mb-10 lg:mb-12">

//           {/* Company Info */}
//           <div className="sm:col-span-2 lg:col-span-1">

//             <img
//               src={logo}
//               alt="MORROCARS"
//               className="h-12 sm:h-14 w-auto mb-4"
//             />

//             <p className="text-[#BFC2C7] mb-6 leading-relaxed text-sm sm:text-base max-w-sm">
//               Morocco's premier automotive marketplace. Buy and sell vehicles
//               with confidence.
//             </p>

//             {/* Social Icons */}
//             <div className="flex gap-3">

//               <a
//                 href="#"
//                 aria-label="Facebook"
//                 className="
//                   w-9 h-9 sm:w-10 sm:h-10
//                   bg-white/10
//                   rounded-full
//                   flex items-center justify-center
//                   hover:bg-[#1E6DFF]
//                   transition-colors
//                 "
//               >
//                 <Facebook className="w-4 h-4 sm:w-5 sm:h-5" />
//               </a>

//               <a
//                 href="#"
//                 aria-label="Twitter"
//                 className="
//                   w-9 h-9 sm:w-10 sm:h-10
//                   bg-white/10
//                   rounded-full
//                   flex items-center justify-center
//                   hover:bg-[#1E6DFF]
//                   transition-colors
//                 "
//               >
//                 <Twitter className="w-4 h-4 sm:w-5 sm:h-5" />
//               </a>

//               <a
//                 href="#"
//                 aria-label="Instagram"
//                 className="
//                   w-9 h-9 sm:w-10 sm:h-10
//                   bg-white/10
//                   rounded-full
//                   flex items-center justify-center
//                   hover:bg-[#1E6DFF]
//                   transition-colors
//                 "
//               >
//                 <Instagram className="w-4 h-4 sm:w-5 sm:h-5" />
//               </a>

//               <a
//                 href="#"
//                 aria-label="LinkedIn"
//                 className="
//                   w-9 h-9 sm:w-10 sm:h-10
//                   bg-white/10
//                   rounded-full
//                   flex items-center justify-center
//                   hover:bg-[#1E6DFF]
//                   transition-colors
//                 "
//               >
//                 <Linkedin className="w-4 h-4 sm:w-5 sm:h-5" />
//               </a>

//             </div>
//           </div>

//           {/* Quick Links */}
//           <div>
//             <h4 className="text-base sm:text-lg font-semibold mb-4">
//               Quick Links
//             </h4>

//             <ul className="space-y-2.5 sm:space-y-3">

//               <li>
//                 <Link
//                   to="/search"
//                   className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
//                 >
//                   Browse Vehicles
//                 </Link>
//               </li>

//               <li>
//                 <Link
//                   to="/sell"
//                   className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
//                 >
//                   Sell Your Vehicle
//                 </Link>
//               </li>

//               <li>
//                 <Link
//                   to="/sell/professional"
//                   className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
//                 >
//                   Become a Dealer
//                 </Link>
//               </li>

//               <li>
//                 <Link
//                   to="/pricing"
//                   className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
//                 >
//                   Pricing Plans
//                 </Link>
//               </li>

//               <li>
//                 <Link
//                   to="/blog"
//                   className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
//                 >
//                   Blog
//                 </Link>
//               </li>

//             </ul>
//           </div>

//           {/* Support */}
//           <div>
//             <h4 className="text-base sm:text-lg font-semibold mb-4">
//               Support
//             </h4>

//             <ul className="space-y-2.5 sm:space-y-3">

//               <li>
//                 <Link
//                   to="/faq"
//                   className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
//                 >
//                   Help Center
//                 </Link>
//               </li>

//               <li>
//                 <Link
//                   to="/faq"
//                   className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
//                 >
//                   FAQs
//                 </Link>
//               </li>

//               <li>
//                 <Link
//                   to="/contact"
//                   className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
//                 >
//                   Contact Us
//                 </Link>
//               </li>

//               <li>
//                 <Link
//                   to="/privacy"
//                   className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
//                 >
//                   Privacy Policy
//                 </Link>
//               </li>

//               <li>
//                 <Link
//                   to="/terms"
//                   className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
//                 >
//                   Terms of Service
//                 </Link>
//               </li>

//             </ul>
//           </div>

//           {/* Contact */}
//           <div>
//             <h4 className="text-base sm:text-lg font-semibold mb-4">
//               Contact
//             </h4>

//             <ul className="space-y-4">

//               <li className="flex items-start gap-3">

//                 <MapPin className="w-5 h-5 text-[#1E6DFF] mt-1 flex-shrink-0" />

//                 <span className="text-[#BFC2C7] text-sm sm:text-base leading-relaxed">
//                   123 Boulevard Mohammed V,
//                   <br />
//                   Casablanca, Morocco
//                 </span>

//               </li>

//               <li className="flex items-center gap-3">

//                 <Phone className="w-5 h-5 text-[#1E6DFF] flex-shrink-0" />

//                 <a
//                   href="tel:+212522123456"
//                   className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base break-all"
//                 >
//                   +212 522 123 456
//                 </a>

//               </li>

//               <li className="flex items-start gap-3">

//                 <Mail className="w-5 h-5 text-[#1E6DFF] flex-shrink-0 mt-0.5" />

//                 <a
//                   href="mailto:contact@morrocars.ma"
//                   className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base break-all"
//                 >
//                   contact@morrocars.ma
//                 </a>

//               </li>

//             </ul>
//           </div>

//         </div>

//         {/* Bottom Bar */}
//         <div className="pt-6 sm:pt-8 border-t border-white/10">

//           <div className="flex flex-col md:flex-row items-center md:justify-between gap-4 text-[#BFC2C7] text-sm text-center md:text-left">

//             <p>
//               © 2026 MORROCARS. All rights reserved.
//             </p>

//             <div className="flex flex-wrap justify-center gap-x-5 gap-y-2">

//               <Link
//                 to="/privacy"
//                 className="hover:text-[#1E6DFF] transition-colors"
//               >
//                 Privacy
//               </Link>

//               <Link
//                 to="/terms"
//                 className="hover:text-[#1E6DFF] transition-colors"
//               >
//                 Terms
//               </Link>

//               <Link
//                 to="/privacy"
//                 className="hover:text-[#1E6DFF] transition-colors"
//               >
//                 Cookies
//               </Link>

//             </div>

//           </div>

//         </div>

//       </div>
//     </footer>
//   );
// }
// src/components/Footer.jsx
import {
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Mail,
  Phone,
  MapPin,
} from 'lucide-react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next'; // 👈 Add this
import logo from '../../imports/logo-MORROCARS.png';

export function Footer() {
  const { t } = useTranslation('common'); // 👈 Add this

  return (
    <footer className="w-full overflow-hidden bg-gradient-to-br from-[#2D323A] via-[#1E1E26] to-[#121212] text-white">
      {/* Newsletter Section */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 lg:py-12">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 md:gap-8">
            <div className="w-full md:flex-1">
              <h3 className="text-xl sm:text-2xl mb-2 font-semibold">
                {t('footer.newsletter.title')}
              </h3>
              <p className="text-[#BFC2C7] text-sm sm:text-base leading-relaxed">
                {t('footer.newsletter.description')}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto md:min-w-[420px]">
              <input
                type="email"
                placeholder={t('footer.newsletter.placeholder')}
                className="
                  w-full
                  sm:flex-1
                  sm:min-w-0
                  px-4
                  py-3
                  rounded-xl
                  bg-white/10
                  border border-white/20
                  focus:outline-none
                  focus:ring-2
                  focus:ring-[#1E6DFF]
                  focus:border-transparent
                  placeholder-[#BFC2C7]
                  text-white
                "
              />
              <button
                type="button"
                className="
                  w-full
                  sm:w-auto
                  px-6
                  py-3
                  bg-[#1E6DFF]
                  text-white
                  rounded-xl
                  hover:bg-[#1557d9]
                  transition-colors
                  whitespace-nowrap
                "
              >
                {t('footer.newsletter.button')}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 lg:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 mb-10 lg:mb-12">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <img
              src={logo}
              alt="MORROCARS"
              className="h-12 sm:h-14 w-auto mb-4"
            />

            <p className="text-[#BFC2C7] mb-6 leading-relaxed text-sm sm:text-base max-w-sm">
              {t('footer.company.description')}
            </p>

            <div className="flex gap-3">
              <a
                href="#"
                aria-label="Facebook"
                className="
                  w-9 h-9 sm:w-10 sm:h-10
                  bg-white/10
                  rounded-full
                  flex items-center justify-center
                  hover:bg-[#1E6DFF]
                  transition-colors
                "
              >
                <Facebook className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
              <a
                href="#"
                aria-label="Twitter"
                className="
                  w-9 h-9 sm:w-10 sm:h-10
                  bg-white/10
                  rounded-full
                  flex items-center justify-center
                  hover:bg-[#1E6DFF]
                  transition-colors
                "
              >
                <Twitter className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
              <a
                href="#"
                aria-label="Instagram"
                className="
                  w-9 h-9 sm:w-10 sm:h-10
                  bg-white/10
                  rounded-full
                  flex items-center justify-center
                  hover:bg-[#1E6DFF]
                  transition-colors
                "
              >
                <Instagram className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
              <a
                href="#"
                aria-label="LinkedIn"
                className="
                  w-9 h-9 sm:w-10 sm:h-10
                  bg-white/10
                  rounded-full
                  flex items-center justify-center
                  hover:bg-[#1E6DFF]
                  transition-colors
                "
              >
                <Linkedin className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-4">
              {t('footer.quick_links.title')}
            </h4>
            <ul className="space-y-2.5 sm:space-y-3">
              <li>
                <Link
                  to="/search"
                  className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
                >
                  {t('footer.quick_links.browse')}
                </Link>
              </li>
              <li>
                <Link
                  to="/sell"
                  className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
                >
                  {t('footer.quick_links.sell')}
                </Link>
              </li>
              <li>
                <Link
                  to="/sell?type=company"
                  className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
                >
                  {t('footer.quick_links.dealer')}
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
                >
                  {t('footer.quick_links.pricing')}
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
                >
                  {t('footer.quick_links.blog')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-4">
              {t('footer.support.title')}
            </h4>
            <ul className="space-y-2.5 sm:space-y-3">
              <li>
                <Link
                  to="/faq"
                  className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
                >
                  {t('footer.support.help')}
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
                >
                  {t('footer.support.faq')}
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
                >
                  {t('footer.support.contact')}
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
                >
                  {t('footer.support.privacy')}
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base"
                >
                  {t('footer.support.terms')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-4">
              {t('footer.contact.title')}
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#1E6DFF] mt-1 flex-shrink-0" />
                <span className="text-[#BFC2C7] text-sm sm:text-base leading-relaxed">
                  {t('footer.contact.address')}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#1E6DFF] flex-shrink-0" />
                <a
                  href={`tel:${(t('footer.contact.phone') || '0661768843').replace(/\s+/g, '')}`}
                  className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base break-all"
                >
                  {t('footer.contact.phone')}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#1E6DFF] flex-shrink-0 mt-0.5" />
                <a
                  href="mailto:contact@morrocars.ma"
                  className="text-[#BFC2C7] hover:text-[#1E6DFF] transition-colors text-sm sm:text-base break-all"
                >
                  {t('footer.contact.email')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center md:justify-between gap-4 text-[#BFC2C7] text-sm text-center md:text-left">
            <p>
              {t('footer.bottom.copyright')}
            </p>
            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2">
              <Link
                to="/privacy"
                className="hover:text-[#1E6DFF] transition-colors"
              >
                {t('footer.bottom.privacy')}
              </Link>
              <Link
                to="/terms"
                className="hover:text-[#1E6DFF] transition-colors"
              >
                {t('footer.bottom.terms')}
              </Link>
              <Link
                to="/privacy"
                className="hover:text-[#1E6DFF] transition-colors"
              >
                {t('footer.bottom.cookies')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
